import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import BurgerMenuItemThirdLevel from './BurgerMenuItemThirdLevel';

const BurgerMenuItemSecondLevel = ({
                                     title, url, subtree, activeLevel, levelsHandler, backBtnHandler,
                                     setThirdLevelTitle, backButtonLabel, attributes, obfuscate,
                                     obfuscateDataUrl, classStyle, disableForLanguage
                                   }) => {
  const [thirdLevelIsOpen, setThirdLevelIsOpen] = useState(false);

  useEffect(() => {
    if (activeLevel === 'second') {
      const timer = setTimeout(() => setThirdLevelIsOpen(false), 500);
      return () => clearTimeout(timer);
    }
  }, [activeLevel]);

  const openMenuThirdLevel = () => {
    setThirdLevelIsOpen(true);
    levelsHandler('third');
    setThirdLevelTitle(title);
  };

  if (disableForLanguage) return null;

  const hasChildren = subtree && Object.keys(subtree).length > 0;
  const classFromBO = attributes?.class || '';
  const targetFromBO = attributes?.target || '';

  const renderLink = () => {
    if (obfuscate && !hasChildren) {
      return <span className={cn('obfuscate', classFromBO)} data-link={obfuscateDataUrl} data-target={targetFromBO}>{title}</span>;
    }
    if (hasChildren) {
      return <span className="hasChildren" onClick={openMenuThirdLevel}>{title}</span>;
    }
    return <a href={url} className={cn(classFromBO)} target={targetFromBO}>{title}</a>;
  };

  return (
    <div className={cn('mobile-menu__item', classStyle)}>
      {renderLink()}
      {thirdLevelIsOpen && (
        <div className="mobile-menu__third-level">
          <div className="mobile-menu__back-btn" onClick={() => levelsHandler('second')}>
            {backButtonLabel}
          </div>
          {Object.keys(subtree).map((key) => (
            <BurgerMenuItemThirdLevel key={key} {...subtree[key]} />
          ))}
        </div>
      )}
    </div>
  );
};

export default BurgerMenuItemSecondLevel;
